/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{{scjss_sitecore_apiKey}}",
  "sitecoreApiHost": "{{scjss_sitecore_layoutServiceHost}}",
  "jssAppName": "cms-sitecore",
  "layoutServiceConfigurationName": "jss",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/cms-sitecore",
  "env": "{{scjss_endpoints_env}}",
  "app": "{{scjss_endpoints_app}}",
  "professions": "{{scjss_endpoints_professions}}",
  "portal": "{{scjss_endpoints_portal}}",
  "naics": "{{scjss_endpoints_naics}}",
  "typeahead": "{{scjss_endpoints_typeahead}}",
  "typeaheadList": "{{scjss_endpoints_typeaheadList}}",
  "tracker": "{{scjss_endpoints_tracker}}",
  "siteSearch": "{{scjss_endpoints_siteSearch}}",
  "sentryDsn": "{{scjss_endpoints_sentryDsn}}",
  "graphQLEndpoint": "{{scjss_sitecore_layoutServiceHost}}/api/cms-sitecore?sc_apikey={{scjss_sitecore_apiKey}}"
};